import { PRESETS } from '@components/App/Modal/PublishModal/constants'
import {
  PublishContent,
  type PublishData,
  PublishFonts,
  PublishPresets,
} from '@storeOld/reducers/publish'

export const getActivePreset = (publishData: PublishData | null) => {
  return publishData?.presetName === null
    ? null
    : PRESETS[publishData?.presetName || PublishPresets.DEFAULT]
}
export const getActiveFont = (publishData: PublishData | null) => {
  return publishData?.fontType || PublishFonts.DEFAULT
}
export const getActiveContent = (publishData: PublishData | null) => {
  return publishData?.contentType || PublishContent.TRANSPARENT
}
export const getActiveBgColor = (publishData: PublishData | null) => {
  return publishData?.bgColor || PRESETS[PublishPresets.DEFAULT].bgColor
}
